import type { TranslationTag } from '@ps/web-core-intl';
import React from 'react';

import type { ClassNameProp } from '../../types/Props';

export type DropDownOptionValue = string | number;
export type DropDownOptionText = React.ReactNode;

interface OwnProps extends ClassNameProp {
  text: DropDownOptionText;
  value?: DropDownOptionValue;
}

const DropDownOption: React.FC<OwnProps> = ({ className, text, value }) => {
  const props = {
    className,
    value
  };

  if (typeof text !== 'object') {
    return <option {...props}>{text?.toString()}</option>;
  }

  const textElement = text as React.ReactElement<{
    children: (translation: TranslationTag) => React.ReactNode;
  }>;

  if (React.isValidElement(textElement)) {
    if (typeof textElement.props.children === 'function') {
      // @ts-ignore // TODO: type mismatch still exist
      return React.cloneElement(textElement, undefined, (translation: TranslationTag) => (
        <option {...props}>{textElement.props.children(translation)}</option>
      ));
    }
    return <option {...props}>{textElement}</option>;
  }

  return <option />;
};

export default DropDownOption;
